import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setActiveTab } from '../../redux/slices/header-slice.js';
import SubLinks from '../../components/header/SubLinks.jsx';
import { scLinks } from '../../config/standard-links.js';

/**
 * Component representing the admin automations home page.
 * @returns {JSX.Element} AdminAutomationsHomePage component.
 */
const ScHomePage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setActiveTab('New SC'));

        return () => {
            dispatch(setActiveTab(null));
        };
    });

    return (
        <div>
            <SubLinks links={scLinks} />
            <div className="admin-container">
                <h2 className="admin-title">New SC Automations</h2>
                <ul className="admin-links-container">
                    <Link to="/scDashboard" className="automation-link">
                        Dashboard
                    </Link>
                    <Link to="/fishbowl" className="automation-link">
                        Fishbowl
                    </Link>
                    <Link to="/scCards" className="automation-link">
                        SC Vetting Cards
                    </Link>
                </ul>
            </div>
        </div>
    );
};

export default ScHomePage;
